import { render, staticRenderFns } from "./AiAgentSidebar.vue?vue&type=template&id=3245be4e&scoped=true"
import script from "./AiAgentSidebar.vue?vue&type=script&lang=js"
export * from "./AiAgentSidebar.vue?vue&type=script&lang=js"
import style0 from "./AiAgentSidebar.vue?vue&type=style&index=0&id=3245be4e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245be4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3245be4e')) {
      api.createRecord('3245be4e', component.options)
    } else {
      api.reload('3245be4e', component.options)
    }
    module.hot.accept("./AiAgentSidebar.vue?vue&type=template&id=3245be4e&scoped=true", function () {
      api.rerender('3245be4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/AiAgentSidebar.vue"
export default component.exports